import { Link } from "react-router-dom";
import { leadershipMembers } from "@/data/leadership";
import LeaderAvatar from "@/components/ui/LeaderAvatar";

const isPlaceholder = (src: string) => !src || src.includes("placeholder");
const featuredLeaders = leadershipMembers.filter((member) =>
  ["J. David Washington", "Shae Rodriguez", "Yolonda R. Kelley, PMP®"].includes(member.name),
);

export default function LeadershipPreview() {
  return (
    <section className="py-24 px-6 bg-[#1A4D3C]">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-3">
            Led by Experience
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-white">
            Our Leadership
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {featuredLeaders.map((leader) => (
            <div
              key={leader.name}
              className="bg-[#0D2E1E] rounded-lg overflow-hidden group ring-1 ring-white/5 hover:ring-[#C9A961]/30 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="aspect-square overflow-hidden">
                {isPlaceholder(leader.img) ? (
                  <LeaderAvatar
                    name={leader.name}
                    variant="dark"
                    className="group-hover:scale-105 transition-transform duration-500"
                  />
                ) : (
                  <img
                    loading="lazy"
                    src={leader.img}
                    alt={leader.name}
                    style={{
                      scale: leader.imageScale,
                      translate: leader.imageTranslateY ? `0 ${leader.imageTranslateY}` : undefined,
                    }}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                )}
              </div>
              <div className="p-7">
                <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-white mb-1">
                  {leader.name}
                </h3>
                <p className="text-[#C9A961] text-sm font-medium mb-4">
                  {leader.title}
                </p>
                <p className="text-white/75 text-xs uppercase tracking-[0.2em] mb-3">
                  {leader.location}
                </p>
                <p
                  className="text-white/80 text-sm leading-relaxed font-['Inter']"
                  dangerouslySetInnerHTML={{ __html: leader.bio }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/leadership"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-md border border-[#C9A961] text-[#C9A961] font-medium text-sm hover:bg-[#C9A961] hover:text-[#1A4D3C] transition-colors whitespace-nowrap cursor-pointer"
          >
            View the Leadership Team <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
